$(document).ready(function () {
    'use strict';

    $(".js_showShareOptions").on('click', function(e) {
        killclick(e);
        addThisInit();
        $(this).parent().find(".addthis_toolbox").stop(true, true).fadeToggle();
        $(this).toggleClass('open');
    });
});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    if ($('.shareWrap').length > 0 && windowWidth > window.breakpoints.mobile) {
        if (!$('.js_showShareOptions').hasClass('open')) {
            $('.js_showShareOptions').trigger('click');
        }
    }

}));